import { render, staticRenderFns } from "./EditarResultadoC3FormComponent.vue?vue&type=template&id=6977199b"
import script from "./EditarResultadoC3FormComponent.vue?vue&type=script&lang=js"
export * from "./EditarResultadoC3FormComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports